import axiosInstance from "./client";

export const fetchData = (id) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`/api/content/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-app-identifier": "nf",
          "x-version": 1,
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          resolve(result.data.data);
        }
      })
      .catch((err) => {
        console.log(err, "fetchData");
        reject(err);
      });
  });
};

export const deleteAccount = (email, password) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .delete(`/api/user/pwa/account?email=${email}&password=${password}`, {
        headers: {
          "Content-Type": "application/json",
          "x-version": 1,
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          // console.log(result.data);
          resolve(result.data);
        }
      })
      .catch((err) => {
        // console.log(err.response.data, "deleteAccount");
        reject(err);
      });
  });
};

export const fetchLiveStream = (id) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`/api/livestream/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-app-identifier": "nf",
          "x-version": 1,
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          resolve(result.data.data);
        }
      })
      .catch((err) => {
        console.log(err, "fetchLiveStream");
        reject(err);
      });
  });
};

export const joinLivestream = (streamId) => {
  return new Promise(async (resolve, reject) => {
    const body = { asHost: false };
    axiosInstance
      .post(`/api/livestream/${streamId}/join`, body, {
        headers: {
          "Content-Type": "application/json",
          "x-app-identifier": "nf",
          "x-version": 1,
        },
      })
      .then((result) => {
        if (result?.status === 200) {
          resolve(result.data.data);
        }
      })
      .catch((err) => {
        console.log(err, "joinLivestream");
        reject(err);
      });
  });
};
